// extracted by mini-css-extract-plugin
module.exports = {"title":"CompaniesModal_title__K9iNT","actions":"CompaniesModal_actions__2po56","cleanButton":"CompaniesModal_cleanButton__1V9od"};